export default [
  /*{
    url: "/admin",
    name: "Admin Home",
    slug: "admin-home",
    icon: "HomeIcon"
  },*/

  {
    url: "/admin/users",
    name: "User",
    slug: "user",
    icon: "UserIcon",
    i18n: "User"
  },
  {
    url: "/admin/request-access",
    name: "Request Access",
    slug: "request-access",
    icon: "TrelloIcon",
    i18n: "RequestAccess"
  },
  /*{
    url: "/admin/coaching-effectiveness",
    name: "Coaching Effectiveness",
    slug: "coaching-effectiveness",
    icon: "UserIcon",
    i18n: "Coaching Effectiveness"
  },*/
  {
    url: "/admin/assign-coach",
    name: "Assign Coach",
    slug: "assign-coach",
    icon: "UsersIcon",
    i18n: "AssignCoach"
  },

  {
    url: "/admin/calender",
    name: "Calender",
    slug: "calender",
    icon: "CalendarIcon",
    i18n: "Schedules"
  },
  {
    url: "/user/auth/logout",
    name: "Log Out",
    slug: "user",
    icon: "LogOutIcon",
    i18n: "LogOut"
  }
];
